import { FC } from 'react';
import LoadingmiddlewareTable from './proto/Loadingmiddleware';
import Emptymiddleware from './proto/Emptymiddleware';
import { TableInputProps } from '../Table';
import { useSelector } from 'react-redux';

const EmptyMiddlewareInstance: FC<TableInputProps> = (props) => {
  const {orderData} = useSelector((state: any) => state.rootReducer.order);

  console.log('orderData', orderData)


  if (orderData.dataRows.length === 0) {
    return <Emptymiddleware {...props} />;
  } else {
    return <LoadingmiddlewareTable {...props} />;
  }
};

export default EmptyMiddlewareInstance;
